export default "__VITE_ASSET__yhi9mj4k__"